<template>
  <ul :class="classList" :id="id" role="tablist" v-bind="otherAttrs">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'TabNav',
  inheritAttrs: false,
  props: {
    pills: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList() {
      const classes = ['nav'];
      if (this.pills) {
        classes.push('nav-pills');
      } else {
        classes.push('nav-tabs');
      }
      if (this.$attrs.class) {
        const customClass = this.$attrs.class;
        if (Array.isArray(customClass)) {
          classes.push(...customClass);
        } else if (typeof customClass === 'string') {
          classes.push(customClass);
        } else if (customClass && typeof customClass === 'object') {
          // Handle object format { 'class-name': true }
          Object.keys(customClass).forEach(key => {
            if (customClass[key]) {
              classes.push(key);
            }
          });
        }
      }
      return classes;
    },
    otherAttrs() {
      const { class: _, ...rest } = this.$attrs;
      return rest;
    }
  }
}
</script>

